export default {
  a: null,
  b: null,
  c: null,
  d: null,
  e: null,
  f: null,
  g: null,
  h: null,
  idc_chassis: true,
  chassis_existence: null,
  chassis_position: null,
  chassis_albatros: null,
  chassis_albrider: null,
  chassis_color_id: null,
  chassis_other: null,
  chassis_number: null,
  idc_shapes: true,
  part1_a: null,
  part1_b: null,
  part2_a: null,
  part2_b: null,
  shapes_parts: null,
  shapes_comments: null,
  shapes_fixing: null,
  abduction_fins: null,
  form_comment: null,
  transfer_id: null,
  other_exterior_finishes: null,
  interior_evazote_measure: null,
  interior_plastazote_measure: null,
  interior_mousse_measure: null,
  thermozaique_color_id: null,
  interior_other: null,
  chassis_protection_bumper: null,
  chassis_protection_finition: null,
  blob_chassis_protection: null,
  strap1: null,
  strap1_strap: null,
  strap1_material_strap: null,
  strap1_velcro: null,
  strap1_clip: null,
  strap1_clips: null,
  strap1_cushion: null,
  strap2: null,
  strap2_strap: null,
  strap2_material_strap: null,
  strap2_velcro: null,
  strap2_clip: null,
  strap2_clips: null,
  strap2_cushion: null,
  sewing_comments: null,
  idc_tablet: true,
  tablet_type: null,
  tablet_comments: null,
  tablet_a: null,
  tablet_b: null,
  tablet_c: null,
  tablet_d: null,
  tablet_e: null,
  tablet_f: null,
  for_testing: null,
  for_finishing: null,
  articles: []
};
